import { render, staticRenderFns } from "./shipButton.vue?vue&type=template&id=927561b2&"
import script from "./shipButton.vue?vue&type=script&lang=ts&"
export * from "./shipButton.vue?vue&type=script&lang=ts&"
import style0 from "./shipButton.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!D:/project/xunjie/ams_old/ams-admin/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib'
import { VList } from 'vuetify/lib'
import { VListTile } from 'vuetify/lib'
import { VListTileTitle } from 'vuetify/lib'
import { VMenu } from 'vuetify/lib'
installComponents(component, {VIcon,VList,VListTile,VListTileTitle,VMenu})
